export default "__VITE_ASSET__DMC9DD1___"